"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlimSectionOptions = exports.SlimSectionBody = exports.SlimSectionHeaderActions = exports.SlimSectionHeaderInputs = exports.SlimSectionTitle = exports.SlimSectionHeader = exports.SlimSection = void 0;
const React = require("react");
const Section_1 = require("../../abstract/Section");
const Header_1 = require("../../abstract/Section/components/Header");
const SlimSection = (_a) => {
    var { children, id } = _a, rest = __rest(_a, ["children", "id"]);
    return (React.createElement(Section_1.Section, Object.assign({ size: "lg", id: id, candycane: true, narrow: true }, rest), children));
};
exports.SlimSection = SlimSection;
/**
 * Renders a SlimSection header
 */
const SlimSectionHeader = (_a) => {
    var { children, isSticky = false, className = "" } = _a, rest = __rest(_a, ["children", "isSticky", "className"]);
    return (React.createElement(Section_1.Header, Object.assign({ className: className, isSticky: isSticky }, rest), children));
};
exports.SlimSectionHeader = SlimSectionHeader;
const SlimSectionTitle = ({ className = "", children }) => (React.createElement(Section_1.Title, { size: 3, className: className }, children));
exports.SlimSectionTitle = SlimSectionTitle;
const SlimSectionHeaderInputs = ({ children }) => React.createElement(Header_1.HeaderInputs, null, children);
exports.SlimSectionHeaderInputs = SlimSectionHeaderInputs;
const SlimSectionHeaderActions = ({ children }) => React.createElement(Header_1.HeaderActions, null, children);
exports.SlimSectionHeaderActions = SlimSectionHeaderActions;
/**
 * Main content of a SlimSection.
 */
const SlimSectionBody = ({ children, className = "" }) => React.createElement(Section_1.Body, { className: className }, children);
exports.SlimSectionBody = SlimSectionBody;
/**
 * Renders a SlimSection header
 */
const SlimSectionOptions = (_a) => {
    var { className = "" } = _a, rest = __rest(_a, ["className"]);
    return React.createElement(Section_1.Options, Object.assign({}, rest));
};
exports.SlimSectionOptions = SlimSectionOptions;
//# sourceMappingURL=index.js.map